module.exports = __webpack_public_path__ + "static/media/snoopyhide.8b5bf2b0.gif";